import {AccountActionTypes, AccountState, REMOVE_ACCOUNT, SET_ACCOUNT, SET_ACCOUNT_ERROR, CLEAR_ACCOUNT_ERROR} from "./types";

export const initialAccountState: AccountState = {
    data: undefined,
    error: undefined
};

export const accountReducer = () => (state: AccountState, action: AccountActionTypes): AccountState => {
    switch (action.type) {
        case SET_ACCOUNT:
            return {...state, data: action.payload, error: undefined};
        case REMOVE_ACCOUNT:
            return {...state, data: undefined, error: undefined};
        case SET_ACCOUNT_ERROR:
            return {...state, error: action.payload};
        case CLEAR_ACCOUNT_ERROR:
            return {...state, error: undefined};
        default:
            return state;
    }
};